// @flow
import React from 'react';

import SectionHeader from 'components/shared/section-header';
import Layout from 'components/shared/layout';
import CanceledInvoiceSVG from 'assets/icons/canceled-invoice.svg';

import { Row } from './styles';

const CanceledInvoice = () => (
  <Layout>
    <Row>
      <SectionHeader
        textAlign="center"
        headline="It looks like this invoice has been canceled."
        subHeadline="Contact your administrator for more info."
      />
      <CanceledInvoiceSVG />
    </Row>
  </Layout>
);

export default CanceledInvoice;



// WEBPACK FOOTER //
// ./src/components/payer/canceled/index.js